import React, { useState } from 'react';
import TableBody from '@mui/material/TableBody';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { AccordionDetails, AccordionSummary, Accordion } from './style';
import Row from './Row';

export default function Accordions({ title = '', information = [], thereIsComponent = () => {}, limit = 0 }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Paper elevation={0} sx={{ borderRadius: 1 }}>
      <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)} sx={{ borderRadius: 5 }}>
        <AccordionSummary style={{ borderRadius: '150px' }}>
          <Typography>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Table>
            <TableBody>
              {information.map(row => (
                <Row key={row} row={row} limit={limit} thereIsComponent={thereIsComponent} />
              ))}
            </TableBody>
          </Table>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
}
